import { useQuery } from '@tanstack/react-query';
import { userService } from '../services/user-service';

/**
 * Hook to fetch workspace users with aggressive caching
 * User lists don't change frequently
 */
export function useWorkspaceUsers(workspaceId: number | undefined) {
  return useQuery({
    queryKey: ['users', workspaceId],
    queryFn: () => userService.getWorkspaceUsers(workspaceId ?? 0),
    enabled: !!workspaceId,
    // Data considered fresh for 5 minutes - users rarely change
    staleTime: 5 * 60 * 1000,
    // Keep in cache for 30 minutes
    gcTime: 30 * 60 * 1000,
    // Don't refetch on mount if data is fresh
    refetchOnMount: false,
    // Don't refetch on window focus
    refetchOnWindowFocus: false,
  });
}
